import { type ChallengeConfig } from '../../challenge-configs-api.ts';
import { type PerformanceTopWin } from '../performance-api.ts';
import { centsToDollars, toCents } from './money.ts';
import { getGameName } from './sessions.ts';
import { type SessionsServiceSession } from './sessions-service-api.ts';

const TOP_WINS_LIMIT = 5;

export const buildTopWins = (
  completed: SessionsServiceSession[],
  configsById: Map<number, ChallengeConfig>
): PerformanceTopWin[] =>
  completed
    .filter((session) => toCents(session.final_payout) > 0)
    .sort(
      (a, b) =>
        toCents(b.final_payout) - toCents(a.final_payout) ||
        b.created_at.localeCompare(a.created_at)
    )
    .slice(0, TOP_WINS_LIMIT)
    .map((session) => ({
      session_id: session.id,
      player_id: session.player_id,
      player_name: session.player_name,
      game_name: getGameName(session, configsById),
      wager: centsToDollars(toCents(session.wager_amount)),
      payout: centsToDollars(toCents(session.final_payout)),
      created_at: session.created_at,
      review_status: session.review_status,
    }));
